<template>
  <div class="auth-page-wrap">
    <div class="auth-card">
      <h1>找回密码</h1>
      <div class="form-field">
        <input v-model="form.email" placeholder="邮箱" />
      </div>
      <div class="form-field pwd-field">
        <input :type="showPassword ? 'text' : 'password'" v-model="form.password" placeholder="新密码"/>
        <span class="eye-btn" @click="showPassword = !showPassword">{{ showPassword ? '🙈' : '👁' }}</span>
      </div>
      <div class="form-field pwd-field">
        <input :type="showPassword2 ? 'text' : 'password'" v-model="form.password2" placeholder="确认新密码"/>
        <span class="eye-btn" @click="showPassword2 = !showPassword2">{{ showPassword2 ? '🙈' : '👁' }}</span>
      </div>
      <div class="form-field code-row">
        <input v-model="form.code" placeholder="邮箱验证码"/>
        <button class="send-code-btn" :disabled="countdown > 0" @click="sendCode">
          {{ countdown > 0 ? countdown + 's' : '发送验证码' }}
        </button>
      </div>
      <button class="btn-submit" @click="reset">确认重置</button>
      <CaptchaModal
          v-if="showCaptcha"
          :img="captchaImg"
          @close="showCaptcha=false"
          @refresh="loadCaptcha"
          @confirm="verifyCaptcha"
      />
    </div>
  </div>
</template>

<script>
import { findPwd, getCaptcha, validateCode } from '@/utils/http'
import CaptchaModal from '@/components/CaptchaModal.vue'
import { bus } from '@/utils/bus'

export default {
  components: { CaptchaModal },
  data() {
    return {
      form: { email: '', code: '', password: '', password2: '' },
      showPassword: false,
      showPassword2: false,
      showCaptcha: false,
      captchaImg: '',
      countdown: 0,
      timer: null,
      token: null
    }
  },
  methods: {
    sendCode() {
      if (!this.form.email) {
        this.$alert('请输入邮箱', '提示')
        return
      }
      this.showCaptcha = true
      this.loadCaptcha()
    },
    async loadCaptcha() {
      const res = await getCaptcha()
      if (res.data) {
        this.captchaImg = 'data:image/png;base64,' + res.data.code
        this.token = res.data.token
      }
    },
    async verifyCaptcha(code) {
      this.showCaptcha = false
      await validateCode({ token: this.token, email: this.form.email, code })
      this.startCountdown()
      this.$message.success('验证码已发送')
    },
    async reset() {
      if (!this.form.code) { this.$alert('请输入验证码', '提示'); return }
      if (this.form.password !== this.form.password2) { this.$alert('两次密码不一致', '提示'); return }
      const res = await findPwd(this.form)
      if (res.status === 200) {
        localStorage.removeItem('uuid')
        localStorage.removeItem('user')
        bus.$emit('logout')
        this.$alert('密码重置成功', '提示')
        this.$router.push('/login')
      } else {
        this.$alert(res.message, '提示')
      }
    },
    startCountdown() {
      this.countdown = 60
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) { clearInterval(this.timer); this.timer = null }
      }, 1000)
    }
  }
}
</script>
